import { Flex, Typography } from "antd";
import { Button } from "@libertify/ui";
import { useAntTheme } from "hooks/useAntTheme";

// Generic quick-filter pill row, shared by any table that offers a row of
// filter buttons (status, type, sort toggles, ...). Each pill is just a
// button with an active state — whether clicking one is exclusive with
// another pill (e.g. selecting "Published" replaces "Ready") is entirely up
// to what the caller wires `onClick` to do, not something this component
// needs to know about.

export type QuickFilterPill = {
  key: string;
  label: string;
  active: boolean;
  onClick: () => void;
};

export type QuickFiltersProps = {
  label?: string;
  pills: QuickFilterPill[];
};

export const QuickFilters = ({ label, pills }: QuickFiltersProps) => {
  const { theme } = useAntTheme();

  const pillStyle = (active: boolean) => ({
    borderColor: active ? theme.colorPrimary : theme.colorBorderSecondary,
    color: active ? theme.colorWhite : theme.colorText,
    backgroundColor: active ? theme.colorPrimary : theme.colorWhite,
  });

  return (
    <Flex align="center" gap={10} wrap="wrap" style={{ flex: "1 1 50%" }}>
      {label && <Typography.Text type="secondary">{label}</Typography.Text>}
      {pills.map((pill) => (
        <Button
          key={pill.key}
          shape="round"
          onClick={pill.onClick}
          variant={pill.active ? "primary" : "outlined"}
          style={pillStyle(pill.active)}
        >
          {pill.label}
        </Button>
      ))}
    </Flex>
  );
};
